import styled, { css } from 'styled-components'
import { colors, device } from '../../styles/GlobalVariables'

export const figureStyle = css`
  margin-top: 40px;
  margin-bottom: 40px;

  figcaption {
    color: ${colors.commentsGray};
    font-weight: 600;

    ${device.medium} {
      color: ${colors.gray};
    }
  }
`
export const StyledP = styled.p`
    font-size: 20px;
    line-height: 27px;
    margin-bottom: 40px;

    ${device.small} {
      margin-bottom: ${props => (props.theme.isFaceLift ? 16 : 20)}px;
    }
  `,
  StyledFigureWrapper = styled.div`
    position: relative;
  `,
  StyledFigure = styled.figure`
    ${figureStyle}
  `,
  StyledBlockquote = styled.blockquote``,
  SpecialBlockquote = styled.blockquote`
    display: none;
  `,
  StyledH3 = styled.h3``,
  StyledUL = styled.ul``,
  StyledOL = styled.ol``,
  StyledMoreArticles = styled.div`
    ul li {
      font-size: ${props => (props.theme.isFaceLift ? 18 : 24)}px;
      margin-bottom: 5px;
      line-height: 1;

      &:before {
        top: 0;
      }
    }
  `
